var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "pc-psp-container" } }, [
    _c(
      "div",
      { staticClass: "mt-2 mb-3 border-bottom-line pb-4" },
      [
        _c("product-search-header", {
          attrs: { initialSelectedFilters: _vm.initialSelectedFilters }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "wf-page-controls mt-4 mt-lg-0 " }, [
      _c(
        "div",
        { staticClass: "wf-page-controls-items-new align-items-baseline" },
        [
          _c(
            "div",
            {
              staticClass:
                "wf-page-control-item wf-page-control-item-current-refinements"
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex cursor-pointer",
                  on: { click: _vm.hideShowFilters }
                },
                [
                  _c("div", { staticClass: "text-uppercase font-size-18" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.toggleButton ? _vm.showFilter : _vm.hideFilter
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass:
                      "png-icon png-icon-icons-glyph--k-sort-filter ml-3"
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "\n          wf-page-control-item wf-page-control-item-product-display-controls\n        "
            },
            [_c("wf-product-display-controls")],
            1
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wf-product-category-new" }, [
      _c("div", { staticClass: "wf-product-category-sidebar-mobile" }, [
        _c(
          "div",
          {
            staticClass: "wf-side-collapse",
            attrs: { id: "filters-side-collapse" }
          },
          [
            _c(
              "div",
              { staticClass: "wf-side-collapse-header justify-content-end" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "wf-side-collapse-button wf-side-collapse-button-close btn",
                    attrs: { type: "button" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString["product.search.close.button"]
                        ) +
                        "\n            "
                    ),
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-glyph--g-close",
                      attrs: { "aria-label": "close button" }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wf-side-collapse-body" }, [
              _c(
                "div",
                { staticClass: "wf-side-collapse-section border-bottom-line" },
                [
                  _c("current-filters", {
                    on: { clearAllFilters: _vm.clearAllFilters }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wf-side-collapse-section" },
                [_c("side-filters")],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.toggleButton
        ? _c(
            "div",
            { staticClass: "wf-product-category-sidebar-desktop mt-2" },
            [
              _c(
                "div",
                { staticClass: "flex column border-bottom-line" },
                [
                  _c("current-filters", {
                    on: { clearAllFilters: _vm.clearAllFilters }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("side-filters")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wf-product-category-results" }, [
        _c("div", { staticClass: "wf-product-category-results" }, [
          _c("section", {}, [
            _c("div", {}, [
              _c("div", { staticClass: "wf-product-category-results" }, [
                _c(
                  "div",
                  {
                    key: _vm.tileSize,
                    staticClass:
                      "wf-search-results wf-search-results-view-mode-swatch",
                    class: ["wf-search-results-tile-size-" + _vm.tileSize]
                  },
                  [
                    _c("pc-gtm-event-logger", {
                      key: _vm.items.length,
                      attrs: {
                        "product-impressions": _vm.items,
                        "product-impression-filter": _vm.getFilterObject(),
                        "event-name": _vm.GTMEventName,
                        "product-impression-start-index":
                          (_vm.pageNumber - 1) * _vm.pageSize,
                        "product-impression-image-type": _vm.viewMode,
                        "selected-filters": _vm.selectedFilters,
                        "in-stock": _vm.inStock,
                        "filter-by-face-weight": _vm.filterByFaceWeight
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.items, function(item, index) {
                      return _c("product-search-result", {
                        key: _vm.itemKey(item.styleNumber),
                        attrs: {
                          item: item,
                          "product-index": index,
                          "is-compare": true,
                          "toggle-button": _vm.toggleButton
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm.showLoadMore
                      ? _c("pc-load-more", {
                          attrs: { "load-more": _vm.onLoadMore }
                        })
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.items.length === 0 && !_vm.isFetching
                  ? _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$resourceString["common.noResults"]) +
                          "\n              "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }